import './Footer.css';

function getCurrentYear() {
  return new Date().getFullYear();
}

function Footer() {
  return (
    <footer className="container-fluid footer">
      <div className="row text-white py-4">
        <div className="col-sm text-center">С любовью к лыжному спорту</div>
        <div className="col-sm text-center">© Федерация лыжных гонок Саратовской области, {getCurrentYear()}</div>
      </div>
    </footer>
  );
}

export default Footer;